import { useNavigate } from "react-router-dom";
import { FlowController } from "../FlowController/FlowController";
import { LinkingOTP } from "../AccountLink/flowScreens/LinkingOTP";
import { Success } from "../AccountLink/flowScreens/Success";
import { GetStarted } from "./GetStarted";
import { TermOfUse } from "./TermOfUse";
import { RegistrationDetails } from "./RegistrationDetails";
import { VerifyEmail } from "./VerifyEmail";

function RegistrationFlow({ location = {} }) {
  const navigate = useNavigate();
  const betweenScreens = () => {
    window.scrollTo(0, 0);
  };
  const screens = {
    GetStarted,
    TermOfUse,
    RegistrationDetails,
    VerifyEmail,
    OTP: LinkingOTP,
    Success,
  };
  const { state } = location;
  const params = {
    name: state?.name ?? "",
    email: state?.email ?? "",
    password: state?.password ?? "",
    steps: [1, 2, 3],
    currentStep: state ? state.currentStep || "" : 1,
    closeFunction: () => navigate("/"),
  };

  return (
    <FlowController
      screens={screens}
      initialScreen="GetStarted"
      initialParams={params}
      betweenScreens={betweenScreens}
    />
  );
}

export { RegistrationFlow };
